var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessibleForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5.0968C18.8954 5.0968 18 5.99223 18 7.0968C18 8.20137 18.8954 9.0968 20 9.0968C21.1046 9.0968 22 8.20137 22 7.0968C22 5.99223 21.1046 5.0968 20 5.0968ZM17 19.5568H15C15 21.2068 13.65 22.5568 12 22.5568C10.35 22.5568 9 21.2068 9 19.5568C9 17.9068 10.35 16.5568 12 16.5568V14.5568C9.24 14.5568 7 16.7968 7 19.5568C7 22.3168 9.24 24.5568 12 24.5568C14.76 24.5568 17 22.3168 17 19.5568ZM20 16.0568H18.14L19.81 12.3868C20.42 11.0568 19.44 9.5568 17.96 9.5568H12.76C11.95 9.5568 11.22 10.0268 10.89 10.7568L10.61 11.5168C10.4 12.0768 10.72 12.6868 11.29 12.8468C11.78 12.9868 12.29 12.7368 12.49 12.2668L12.79 11.5568H15L13.17 15.6568C12.57 16.9868 13.56 18.5568 15.02 18.5568H20V22.5568C20 23.1068 20.45 23.5568 21 23.5568C21.55 23.5568 22 23.1068 22 22.5568V18.0568C22 16.9568 21.1 16.0568 20 16.0568Z",
    fill: "#8C99B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibleForward);
export default __webpack_public_path__ + "static/media/accessible_forward.c7d583712ca2795bece955de7050053b.svg";
export { ForwardRef as ReactComponent };